/* eslint-disable no-param-reassign */
/**
 * Shows or hides elements based on CSS classes for printing
 */
export const handleShowHideElements = (clonedContent: HTMLElement) => {
  clonedContent.style.display = 'block';
  clonedContent.style.visibility = 'visible';

  clonedContent.querySelectorAll('.no-display').forEach(el => {
    (el as HTMLElement).style.display = 'block';
  });

  clonedContent.querySelectorAll('.no-print').forEach(el => {
    (el as HTMLElement).style.display = 'none';
  });
};

/**
 * Calculates page height for printing
 */
export const calculatePageHeight = (index: number): number => {
  const header = document.querySelector('.printable-tab-header');
  const headerHeight = header?.getBoundingClientRect().height || 0;
  const A4_HEIGHT_MM = 297;

  return index === 0 ? A4_HEIGHT_MM - headerHeight : A4_HEIGHT_MM;
};

/**
 * Creates a styled clone of an element for printing
 */
export const createStyledClone = (source: HTMLElement): HTMLElement => {
  // Create a hidden container in the DOM
  const hiddenWrapper = document.createElement('div');
  hiddenWrapper.style.position = 'fixed';
  hiddenWrapper.style.left = '-9999px';
  hiddenWrapper.style.top = '0';
  hiddenWrapper.style.visibility = 'hidden';
  hiddenWrapper.style.width = '1000px';
  hiddenWrapper.style.zIndex = '-1';

  document.body.appendChild(hiddenWrapper);

  const clonedNode = source.cloneNode(true) as HTMLElement;
  hiddenWrapper.appendChild(clonedNode);

  return hiddenWrapper;
};
